export type GetValueOptions = {
  prefix?: string;
};

export function getValue(value: string, options: GetValueOptions = {}): string {
  if (options.prefix && value.includes(options.prefix)) {
    const [_, right]: string[] = value.split(options.prefix);
    return right ? `${options.prefix}${right}` : '';
  }
  return value;
}
